export const DEFAULT_STATE = {
  attachments: {},
  coding: {},
  dataCentrifuge: {},
  filters: { traits: { collapsed: false }, questions: { collapsed: false } },
  variables: {},
  weighting: {},
  export: { crosstab: {}, response: {}, summary: {}, presentation: {}, specific: {} }
}

// The Filters tab's unapplied edit, emptied; a tab reopened on it starts from the applied filter.
export const clearedFiltersEdit = { mode: null, basic: null, advanced: null, reportId: null, pattern: null }

export const sidebarReducer = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case 'UPDATE_STATE': {
      return {
        ...state,
        [action.key]:
          null === action.state
            ? null
            : {
                ...state[action.key],
                ...action.state
              }
      }
    }
    default:
      throw new Error('Unknown action type')
  }
}
